import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>Copyright © 2025 - Versão 1.0 </span>
					</div>
					<div className='col-auto'>
						<small className='fw-bold'>Nexture</small>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
